






































































































































































import WidgetMixins from '../../../../mixins/WidgetMixins';
import Component, { mixins } from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import { PayloadState } from '@/types/types';
import {
  IEmailRecipient,
  IEmailTemplate,
  IEmailTemplateDetail,
  IEmailTemplateVariable,
  ISendTemplateEmailPayload,
} from '@/store/modules/emails-management';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { VTextField, VTextarea } from 'vuetify/lib';
extend('required', {
  ...required,
  message: 'Field is required',
});

const emailsManagementModule = namespace('emailsManagement');

@Component({
  name: 'SendTemplateEmailDialog',
  components: {
    ValidationObserver,
    ValidationProvider,
    VTextField,
    VTextarea,
  },
})
export default class SendTemplateEmailDialog extends mixins(WidgetMixins) {
  @Getter('getResetFormState') resetFormState!: boolean;
  @emailsManagementModule.Getter('getTemplates') templates!: IEmailTemplate[];
  @emailsManagementModule.Getter('getTemplateDetail') templateDetail!: IEmailTemplateDetail | null;
  @Prop({ default: false, required: true }) state!: boolean;
  @Prop({ default: false }) dialogLoading!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: () => [] }) recipients!: IEmailRecipient[];
  @Prop({ default: 0 }) excludedCount!: number;

  templateId: string | null = null;
  subject: string | null = null;
  variableValues: Record<string, string> = {};
  // Variable keys rendered as textareas — long-form content.
  longVariables: string[] = ['message', 'invitationMessage', 'impact'];

  get visibleRecipients(): IEmailRecipient[] {
    return this.recipients.slice(0, 4);
  }

  get editableVariables(): IEmailTemplateVariable[] {
    return (this.templateDetail?.variables ?? []).filter(variable => variable.key !== 'name');
  }

  get hasNameVariable(): boolean {
    return (this.templateDetail?.variables ?? []).some(variable => variable.key === 'name');
  }

  get previewSubject(): string {
    const raw = this.subject || this.templateDetail?.subject || '';
    return this.substituteVariables(raw) || '(no subject)';
  }

  get previewHtml(): string {
    return this.substituteVariables(this.templateDetail?.html ?? '');
  }

  prettifyKey(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, char => char.toUpperCase());
  }

  substituteVariables(content: string): string {
    return content.replace(/\{\{\{?\s*(\w+)\s*\}?\}\}/g, (match, key) => {
      if (key === 'name') {
        return this.recipients[0]?.name || this.recipients[0]?.email || 'Recipient';
      }
      const value = this.variableValues[key];
      if (value) return value;
      const variable = (this.templateDetail?.variables ?? []).find(item => item.key === key);
      if (variable && variable.fallbackValue !== null && `${variable.fallbackValue}` !== '') {
        return `${variable.fallbackValue}`;
      }
      return this.prettifyKey(key);
    });
  }

  @Watch('state')
  onStateChange(open: boolean): void {
    if (open && this.templates.length === 0) {
      this.$store.dispatch('emailsManagement/listTemplates');
    }
  }

  @Watch('templateId')
  onTemplateChange(id: string | null): void {
    if (id) {
      this.$store.dispatch('emailsManagement/templateDetail', id);
    }
  }

  @Watch('templateDetail')
  onTemplateDetailChange(detail: IEmailTemplateDetail | null): void {
    const values: Record<string, string> = {};
    (detail?.variables ?? [])
      .filter(variable => variable.key !== 'name')
      .forEach(variable => {
        values[variable.key] = this.variableValues[variable.key] ?? '';
      });
    this.variableValues = values;
  }

  @Watch('resetFormState')
  onFormChange(payload: boolean) {
    if (payload) {
      this.templateId = null;
      this.subject = null;
      this.variableValues = {};
    } else this.$store.dispatch('resetFormValues', false, { root: true });
  }

  @Emit('sendTemplateEmail')
  sendTemplateEmail(): ISendTemplateEmailPayload {
    return {
      templateId: this.templateId as string,
      ...(this.subject && { subject: this.subject }),
      recipients: this.recipients.map(({ email, name }) => ({
        email,
        ...(name && { name }),
        ...(Object.keys(this.variableValues).length > 0 && {
          variables: { ...this.variableValues },
        }),
      })),
    };
  }

  @Emit('actions')
  close(): PayloadState {
    return {
      idx: 'sendEmail',
      state: false,
    };
  }
}
